import {editSowCycle} from "../../../api/cycles/editSowCycle";
import {
    updateWeightingNotificationFailure,
    updateWeightingNotificationSuccess,
} from "../../../api/events/Weighting";
import EventTypes from "@wesstron/utils/Api/constants/eventTypes";
import {get} from "lodash";

export function submit(value, dispatch, props) {
    const copy = JSON.parse(JSON.stringify(value));
    delete copy._Name;
    return editSowCycle(
        {AnmID: value.AnmID, eventsToUpdate: [copy], eventsToDelete: []},
        {FarmID: value.FarmID}
    )
        .then((res) => {
            props.handleHide();
            updateWeightingNotificationSuccess(res);
        })
        .catch((e) => {
            updateWeightingNotificationFailure(e);
        });
}

export function validate(values, props) {
    const {t} = props;
    const errors = {EvData: {}};
    const maxWeight = 400000;
    const amount =
        get(values, "EvData.AmnCnt", 0) || get(values, "AnmCnt", 0) || 1;
    if (!values.EvTime) {
        errors.EvTime = t("required");
    }
    if (!values.AnmCnt) {
        errors.AnmCnt = t("required");
    } else if (values.AnmCnt <= 0) {
        errors.AnmCnt = t("errors.lessVal", {count: 1});
    }
    if (values.EvData) {
        if (!values.EvData.Weight) {
            errors.EvData.Weight = t("required");
        } else if (values.EvData.Weight <= 1) {
            errors.EvData.Weight = t("errors.lessVal", {count: 1});
        } else if (
            values.EvCode === EventTypes.WEIGHTING &&
            values.EvData.Weight > maxWeight
        ) {
            errors.EvData.Weight = t("errors.toLargeValue");
        } else if (
            values.EvCode === EventTypes.SELL &&
            values.EvData.Weight > maxWeight * amount
        ) {
            errors.EvData.Weight = t("errors.toLargeValue");
        }
    }

    return errors;
}
